import { render } from "./sectionHeader.vue?vue&type=template&id=227e69b0"
import script from "./sectionHeader.vue?vue&type=script&lang=js"
export * from "./sectionHeader.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__